<template>
  <div id="radish-drawer">
    <div class="part">
      <div class="common-title">填写人才画像即完成项目新建</div>
      <div style="font-size: 16px;font-weight: bold;margin:10px 0;">
        以下标签影响一键及智能匹配，请客户经理或项目经理填写
      </div>
      <p class="common-tips">（项目匹配时可以添加多个职能模块，点击加号可以增加职能模块条件）</p>
      <div class="main-part">
        <radishDrawerFunction
          v-for="(item, idx) in functions"
          :key="item.tempId"
          :functions="functions[idx]"
          :idx="idx"
          :length="functions.length"
          @addFunction="addFunction"
          @removeFunction="removeFunction"
        ></radishDrawerFunction>
        <div class="info">
          <el-row :gutter="10" type="flex" align="middle" style="margin-bottom:15px;">
            <el-col :span="4" style="text-align:center">平台</el-col>
            <el-col :span="8" style="display:flex;align-items:center">
              <el-select
                v-model="project.平台"
                size="mini"
                placeholder="下拉选择,可多选"
                multiple
                style="margin-right:5px"
              >
                <el-option v-for="(value, key) in constantData.平台" :key="key" :value="key" :label="value"></el-option>
              </el-select>
            </el-col>
            <el-col :span="4" style="text-align:center">职级</el-col>
            <el-col :span="8" style="display:flex;align-items:center">
              <el-select
                v-model="project.职级"
                size="mini"
                placeholder="下拉选择,可多选"
                multiple
                style="margin-right:5px"
              >
                <el-option v-for="(value, key) in constantData.职级" :key="key" :value="key" :label="value"></el-option>
              </el-select>
              <el-tooltip placement="right">
                <div slot="content">
                  1: 高管（公司层面高管）, <br />2: 部门总（部门的行政负责人）, <br />3:
                  部门副总-总助-团队长（部门副手、部门内带管理职责或带小团队的人）, <br />4:
                  部门核心骨干（3年以上经验，但是没有任何管理职责，不带人）, <br />5: 新人（三年以下）,
                </div>
                <el-link icon="el-icon-question" type="primary" :underline="false"></el-link>
              </el-tooltip>
            </el-col>
          </el-row>
          <el-row :gutter="10" type="flex" align="middle">
            <el-col :span="4" style="text-align:center">业绩</el-col>
            <el-col :span="8" style="display:flex;align-items:center">
              <el-select
                v-model="project.业绩"
                size="mini"
                placeholder="下拉选择,可多选"
                multiple
                style="margin-right:5px"
              >
                <el-option v-for="(value, key) in constantData.业绩" :key="key" :value="key" :label="value"></el-option>
              </el-select>
              <el-tooltip placement="right">
                <div slot="content">
                  aaa: 顶尖人才（市场最Top领军人物）, <br />aa: 卓越人才（市场前1/10人才）, <br />a:
                  优秀人才（市场前1/4人才）, <br />b: 良好
                </div>
                <el-link icon="el-icon-question" type="primary" :underline="false"></el-link>
              </el-tooltip>
            </el-col>
            <el-col :span="4" style="text-align:center">地域</el-col>
            <el-col :span="8">
              <el-select v-model="project.地域" size="mini" placeholder="下拉选择,可多选" multiple filterable>
                <el-option
                  v-for="(value, key) in constantData.地域"
                  :key="key"
                  :value="value"
                  :label="value"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="part">
      <div class="common-title">以下为人选标签，如果填写完整有助于系统帮您优先匹配合适人选</div>
      <el-row>
        <el-col :span="5" style="padding-right:20px">
          <div style="display:flex;align-items:center;justify-content:space-between">
            <span>所选标签</span>
            <el-button type="text" @click="clearTags">清空</el-button>
          </div>
          <p class="common-tips">（已选择的标签可以拖拽排序或删除无用标签；排名前五的标签会在项目中重点展示）</p>
          <div class="selected-tags">
            <el-tag
              v-for="(item, idx) in copyProject.标签"
              :key="idx"
              closable
              size="mini"
              style="margin-bottom:10px;margin-right:10px;"
              draggable="true"
              @close="closeTag(item)"
              @drop.native="event => drop(event, idx)"
              @dragover.native="event => allowDrop(event, idx)"
              @dragstart.native="() => drag(idx)"
              >{{ item }}</el-tag
            >
          </div>
        </el-col>
        <el-col :span="15" style="border-left:1px solid #eee;padding-left:20px">
          <el-row type="flex" align="middle" style="margin-bottom:15px;">
            <el-col :span="3">学历要求</el-col>
            <el-col :span="10" style="display:flex;align-items:center">
              <el-select v-model="degree" size="mini" style="margin-right:5px">
                <el-option
                  v-for="(item, idx) in constantData.学历"
                  :key="idx"
                  :label="item"
                  :value="item"
                ></el-option> </el-select
              >及以上
            </el-col>
          </el-row>
          <el-row type="flex" align="middle" style="margin-bottom:15px;">
            <el-col :offset="3">
              <el-checkbox-group v-model="copyProject.标签">
                <el-checkbox label="常青藤（Ivy League）"></el-checkbox>
                <el-checkbox label="清北复交"></el-checkbox>
                <el-checkbox label="985"></el-checkbox>
                <el-checkbox label="211"></el-checkbox>
                <el-checkbox label="海外背景"></el-checkbox>
                <el-checkbox label="QS100"></el-checkbox>
                <el-checkbox label="TIMES100"></el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-row>
          <el-row type="flex" align="middle" style="margin-bottom:15px;">
            <el-col :span="3">年龄要求</el-col>
            <el-col :span="2">
              <el-input v-model="copyProject.年龄要求[0]" size="mini" class="append-mini" @change="ageChange">
                <template slot="append"
                  >岁</template
                >
              </el-input>
            </el-col>
            <el-col :span="1" style="text-align:center">—</el-col>
            <el-col :span="2">
              <el-input v-model="copyProject.年龄要求[1]" size="mini" class="append-mini" @change="ageChange">
                <template slot="append"
                  >岁</template
                >
              </el-input>
            </el-col>
          </el-row>
          <el-row type="flex" align="middle" style="margin-bottom:15px;">
            <el-col :span="3">工作年限</el-col>
            <el-col :span="4">
              <el-input v-model="工作年限" size="mini" class="append-mini" @change="expChange">
                <template slot="append"
                  >年及以上</template
                >
              </el-input>
            </el-col>
          </el-row>
          <el-row type="flex" align="middle" style="margin-bottom:15px;">
            <el-col :span="3">性别趋向</el-col>
            <el-col :span="10">
              <el-radio-group v-model="sex">
                <el-radio :label="'男'"></el-radio>
                <el-radio :label="'女'"></el-radio>
                <el-radio :label="'性别不限'">不限</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
          <el-row type="flex" align="middle"> <el-col :span="3">个性标签</el-col> </el-row>
          <el-row type="flex" align="middle" style="margin-bottom:15px;">
            <el-col :offset="3">
              <div style="margin:10px 0;font-weight:bold">语言能力</div>
              <el-checkbox-group v-model="copyProject.标签" style="line-height:20px">
                <el-checkbox v-for="item in constantData.语言能力" :key="item" :label="item"></el-checkbox>
              </el-checkbox-group>
              <div style="margin:10px 0;font-weight:bold">职业资格</div>
              <el-checkbox-group v-model="copyProject.标签" style="line-height:20px">
                <el-checkbox label="保代"></el-checkbox>
                <el-checkbox label="基金从业资格"></el-checkbox>
                <el-checkbox label="证券从业资格"></el-checkbox>
                <el-checkbox label="CFA"></el-checkbox>
                <el-checkbox label="CPA"></el-checkbox>
                <el-checkbox label="FRM"></el-checkbox>
                <el-checkbox label="律师执业资格"></el-checkbox>
                <el-checkbox label="法律从业资格"></el-checkbox>
              </el-checkbox-group>
              <div style="margin:10px 0;font-weight:bold">领导能力</div>
              <el-checkbox-group v-model="copyProject.标签" style="line-height:20px">
                <el-checkbox v-for="item in constantData.领导能力" :key="item" :label="item"></el-checkbox>
              </el-checkbox-group>
              <div style="margin:10px 0;font-weight:bold">个人风格</div>
              <el-checkbox-group v-model="copyProject.标签" style="line-height:20px">
                <el-checkbox v-for="item in constantData.个人风格" :key="item" :label="item"></el-checkbox>
              </el-checkbox-group>
              <div style="margin:10px 0;font-weight:bold">专业能力</div>
              <el-checkbox-group v-model="copyProject.标签" style="line-height:20px">
                <el-checkbox v-for="item in constantData.专业能力" :key="item" :label="item"></el-checkbox>
              </el-checkbox-group>
              <div style="margin:10px 0;font-weight:bold">心态/性格</div>
              <el-checkbox-group v-model="copyProject.标签" style="line-height:20px">
                <el-checkbox v-for="item in constantData.心态性格" :key="item" :label="item"></el-checkbox>
              </el-checkbox-group>
              <el-row :gutter="20" type="flex" align="middle" style="margin-top:10px;">
                <el-col style="font-weight:bold" :span="4">自定义标签</el-col>
                <el-col :span="10">
                  <el-input
                    v-model="customTag"
                    placeholder="输入关键词,回车即可添加新标签"
                    size="mini"
                    @change="addCustomTag"
                  ></el-input>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <div class="handle-buttons"><el-button size="mini" type="primary" @click="submit">完成</el-button></div>
  </div>
</template>
<script>
import radishDrawerFunction from './radishDrawerFunction.vue'

const constantData = {
  平台: {
    A: '大平台',
    B: '中型平台',
    C: '小平台',
  },
  职级: {
    '1': '1.高管',
    '2': '2.部门总',
    '3': '3.部门副总/总助/团队长',
    '4': '4.部门核心骨干',
    '5': '5.新人三年以下',
  },
  业绩: {
    aaa: 'aaa.领军人物',
    aa: 'aa.卓越人选',
    a: 'a.优秀人选',
    b: 'b.良好',
    c: 'c.一般',
    d: 'd.较差',
  },
  地域: [
    '北京',
    '上海',
    '广州',
    '深圳',
    '香港',
    '成都',
    '杭州',
    '重庆',
    '武汉',
    '苏州',
    '西安',
    '天津',
    '南京',
    '郑州',
    '长沙',
    '沈阳',
    '青岛',
    '宁波',
    '东莞',
    '无锡',
    '昆明',
    '大连',
    '厦门',
    '合肥',
    '佛山',
    '福州',
    '哈尔滨',
    '济南',
    '温州',
    '长春',
    '石家庄',
    '其他',
  ],
  学历: ['学历不限', '博士后', '博士', 'MBA/EMBA', '硕士', '本科', '大专'],
  语言能力: ['英文-1-母语水平', '英文-2-工作语言', '英文-3-可顺利读写，口语较弱', '粤语', '日语', '法语', '小语种'],
  领导能力: ['领导力强', '领导力弱', '逆商高', '逆商低', '强资源人脉'],
  个人风格: [
    '保守',
    '稳健',
    '开拓（追求卓越）',
    '激进（狼性文化）',
    'social型',
    '学术研究型',
    '适合美元',
    '适合人民币',
    '具有创业精神',
    '情商高',
    '校友资源型',
    '政府资源型',
    '远见型','命令型','民主型','赞赏型','变革型','服务型',
  ],
  专业能力: [
    '专业能力强',
    '销售能力强',
    '研究功底扎实',
    '逻辑思维强',
    '思维散乱',
    '沟通能力强',
    '表达能力弱',
    '商业意识强',
    '执行力强',
  ],
  心态性格: [
    '心态积极正向',
    '消极负面',
    '战略思维、注重长远',
    '看重短期',
    '事业心强',
    '追求家庭工作平衡',
    '追求创新',
    '个性求稳',
    '积极进取',
    '结果导向',
  ],
}

export default {
  components: {
    radishDrawerFunction,
  },
  props: {
    project: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      copyProject: {},
      constantData,
      functions: [
        {
          职能模块: '',
          擅长方向: [],
          细分职能: [],
          目标行业: [],
          tempId: 0,
        },
      ],
      标签: [],
      年龄要求: new Array(2),
      工作年限: '',
      degree: '',
      sex: '',
      customTag: '',
    }
  },
  watch: {
    degree(newVal, oldVal) {
      if (!newVal) {
        return
      }
      oldVal &&
        this.copyProject.标签.indexOf(oldVal) !== -1 &&
        this.copyProject.标签.splice(this.copyProject.标签.indexOf(oldVal), 1)
      this.copyProject.标签.every(val => val !== newVal) && this.copyProject.标签.push(newVal)
    },
    sex(newVal, oldVal) {
      if (!newVal) {
        return
      }
      oldVal &&
        this.copyProject.标签.indexOf(oldVal) !== -1 &&
        this.copyProject.标签.splice(this.copyProject.标签.indexOf(oldVal), 1)
      this.copyProject.标签.every(val => val !== newVal) && this.copyProject.标签.push(newVal)
    },
    functions: {
      handler: val => {
        console.log(val)
      },
      deep: true,
    },
    project: {
      async handler(newValue) {
        this.copyProject = newValue
        if (!this.copyProject.标签) this.$set(this.copyProject, '标签', [])
        if (!this.copyProject.年龄要求) this.$set(this.copyProject, '年龄要求', ['', ''])
        this.functions[0].职能模块 = this.copyProject.职能模块
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    submit() {
      this.copyProject.职能模块 = this.functions[0].职能模块
      this.copyProject.目标行业 = this.functions[0].目标行业
      this.copyProject.细分职能 = this.functions[0].细分职能
      this.copyProject.擅长方向 = this.functions[0].擅长方向
      this.$emit('modifyProject', {
        ifClose: true,
        callback: () => {
          this.$message.success('项目信息完善成功!')
          router.replace(`/project20/${this.copyProject._id}`)
        },
      })
    },
    // async modifyProject () {
    //   try {
    //     if (this.copyProject._id) {

    //       await window.app.service('project').modify({
    //         id: this.copyProject._id,
    //         param: this.copyProject,
    //       })

    //       this.copyProject = {}
    //     }
    //   } catch (e) {
    //     this.$message.error(`update project :${e.message}`)
    //   }
    // },
    addFunction() {
      this.functions.push({
        职能模块: '',
        擅长方向: '',
        细分职能: '',
        目标行业: [],
        tempId: this.functions[this.functions.length - 1].tempId + 1,
      })
    },
    removeFunction(data) {
      const tempId = data.tempId
      console.log(data)
      this.functions = this.functions.filter(val => val.tempId !== tempId)
    },
    closeTag(item) {
      this.copyProject.标签.splice(this.copyProject.标签.indexOf(item), 1)
    },
    ageChange() {
      if (!this.copyProject.年龄要求[1] && !this.copyProject.年龄要求[0]) {
        return
      }
      this.copyProject.标签 = this.copyProject.标签.filter(val => !/\d+岁\-\d+岁|小于\d+岁|大于\d+岁/.test(val))
      if (!this.copyProject.年龄要求[1]) {
        this.copyProject.标签.push(`大于${this.copyProject.年龄要求[0]}岁`)
      } else if (!this.copyProject.年龄要求[0]) {
        this.copyProject.标签.push(`小于${this.copyProject.年龄要求[1]}岁`)
      } else {
        this.copyProject.标签.push(`${this.copyProject.年龄要求[0]}岁-${this.copyProject.年龄要求[1]}岁`)
      }
    },
    expChange(val) {
      this.copyProject.标签 = this.copyProject.标签.filter(val => !/工作\d+年及以上/.test(val))
      this.copyProject.标签.push(`工作${val}年及以上`)
    },
    clearTags() {
      this.copyProject.标签 = []
      this.copyProject.年龄要求 = new Array(2)
      this.工作年限 = ''
      this.degree = ''
      this.sex = ''
    },
    addCustomTag(val) {
      this.copyProject.标签.push(val)
      this.customTag = ''
    },
    drop(event, index) {
      const temp = this.copyProject.标签[index]
      const tomoveTag = this.copyProject.标签[this.movetagindex]
      this.copyProject.标签.splice(index, 1, tomoveTag)
      this.copyProject.标签.splice(this.movetagindex, 1, temp)
    },
    allowDrop(event, index) {
      event.preventDefault()
    },
    drag(index) {
      this.movetagindex = index
    },
  },
}
</script>
<style src="../../../statistics/css/addProject.css"></style>
<style scoped>
.part {
  border-bottom: 1px solid #eee;
  padding-bottom: 20px;
}

.selected-tags {
  margin-top: 20px;
}
.append-mini .el-input-group__append {
  padding: 0 5px !important;
}
</style>
